import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AssistantIcon from "../../Assets/images/create-assistant-icon.svg";
import Logo from "../../Assets/images/logo.png";
import CheckMarkIcon from "../../Assets/svgs/CheckMarkIcon";
import AllFormFields from "../../Common/AllFormFields";
import { uploadTalkDetailForm } from "../../Redux/Slice/Talk/UploadTalkDetailFormSlice";
import ReactQuill from "react-quill";

const FormStep = ({
  step,
  setStep,
  setIsLoading,
  callData,
  setCallData,
  showSuccessMessage,
  showErrorMessage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = async (formData) => {
    const payloadFormData = new FormData();
    payloadFormData.append("formId", callData?.form?.id);
    formData?.forEach((e) => {
      if (e?.type == "phone" && e?.value) {
        payloadFormData.append(e?.label, `+${e?.value?.replace(/\D/g, "")}`);
      } else if (e?.value) {
        payloadFormData.append(e?.label, e?.value);
      }
    });
    setIsLoading(true);
    const result = await dispatch(
      uploadTalkDetailForm({ body: payloadFormData, isSourceEmail: true })
    );
    if (
      uploadTalkDetailForm.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      // showSuccessMessage("Form successfully submitted!");
      // setStep(2)
      setStep(3);
      if (
        Object.keys(result?.payload?.data)?.length &&
        result?.payload?.data?.assistantOverrides &&
        Object.keys(result?.payload?.data?.assistantOverrides)?.length
      ) {
        setCallData((prev) => ({
          ...prev,
          assistantOverrides: result?.payload?.data?.assistantOverrides,
        }));
      }
    } else {
      setIsLoading(false);
      showErrorMessage(result?.payload?.error?.message);
    }
  };

  const onClickChatNow = () => {
    setStep(3);
  };

  return (
    <section className="layoutContainer layoutContainer--full">
      <div className="layoutGrid">
        <div className="page page__full">
          <div className="page__head">
            <div className="page__head__logo">
              <img
                src={callData?.contactDetails?.customer?.logo ?? Logo}
                alt="Logo | Vox App"
                style={{ height: "30px" }}
              />
            </div>
          </div>
          <div className="page__body">
            <div className="CreateformBoxChat">
              <div className="CreateformBoxChat__steps">
                <div
                  className={`CreateformBoxChat__steps__item ${
                    step != 1 ? "completed" : "active"
                  } `}
                >
                  <div className="infoDetail">
                    <h4 className="title">Step 1</h4>
                    <p className="para">Instructions</p>
                  </div>
                  {step == 1 ? (
                    <div className="count">1</div>
                  ) : (
                    <div className="count">
                      <CheckMarkIcon />
                    </div>
                  )}
                </div>
                <div
                  className={`CreateformBoxChat__steps__item ${
                    step == 2 ? "active" : step > 2 ? "completed" : ""
                  } `}
                >
                  <div className="infoDetail">
                    <h4 className="title">Step 2</h4>
                    <p className="para">Fill Form Details</p>
                  </div>
                  {step <= 2 ? (
                    <div className="count">2</div>
                  ) : (
                    <div className="count">
                      <CheckMarkIcon />
                    </div>
                  )}
                </div>
              </div>
              <div className="CreateformBoxChat__data">
                {step == 1 ? (
                  <div className="CreateformBoxChat__form">
                    <div className="CreateformBoxChat__form__head">
                      <h3 className="title title--h4">Instructions</h3>
                      <p className="para ql--preview">
                        <ReactQuill
                          value={callData?.form?.instructions}
                          readOnly={true}
                          theme={"bubble"}
                        />
                      </p>
                    </div>
                    <div className="btn__group">
                      <button
                        className="btn btn__primary"
                        onClick={() => setStep(2)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="CreateformBoxChat__form">
                    <div className="CreateformBoxChat__form__head">
                      <h3 className="title title--h4">Fill the details</h3>
                      <p className="para">
                        Note: Fill the details to start chat with Assistant
                      </p>
                    </div>
                    <AllFormFields
                      fieldData={
                        Array.isArray(callData?.form?.fields)
                          ? callData?.form?.fields?.filter(
                              (field) => field?.visible
                            )
                          : []
                      }
                      showErrorMessage={showErrorMessage}
                      onSubmit={onSubmit}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormStep;
